

























import { Component, Vue } from 'vue-property-decorator';
import { SysModule } from '@/store/modules/sys';
import { AppModule } from '@/store/modules/app';
import SysApps from '@/components/Apps/SysApps.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'


@Component({

	name: 'Apps',
  	components: { SysApps, Alert }
})
export default class extends GiganautVue {

	created() {
		SysModule.getApps();
  	}

  	get loading() {
		return SysModule.loading;
  	}
}
